import { Select } from '@/shared/components';
import type { CleaningTeamMemberRequest, UserResponse } from '@/shared/api';
import { PRIVILEGES } from '@stayon/auth-core';

interface Props {
  users: UserResponse[];
  members: CleaningTeamMemberRequest[];
  onToggle: (userId: string) => void;
  onRoleChange: (userId: string, role: CleaningTeamMemberRequest['role']) => void;
}

/** Teamrollen folgen dem effektiven Privileg; der Server erzwingt es erneut. */
export function CleaningTeamMembers({ users, members, onToggle, onRoleChange }: Props) {
  const eligible = users.filter(
    (user) => user.isActive && user.privileges?.includes(PRIVILEGES.cleaningOwnTaskWork),
  );

  if (eligible.length === 0) {
    return <p className="text-ink-faint text-sm">Keine Reinigungsbenutzer verfügbar.</p>;
  }

  return (
    <div className="space-y-2">
      {eligible.map((user) => {
        const member = members.find((item) => item.userId === user.id);
        const canLead = user.privileges?.includes(PRIVILEGES.cleaningAssignmentsManage);
        const name = [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email;
        return (
          <div key={user.id} className="flex flex-wrap items-center justify-between gap-2">
            <label className="text-ink flex min-h-11 min-w-0 items-center gap-2 text-sm">
              <input
                className="size-4"
                type="checkbox"
                checked={Boolean(member)}
                onChange={() => onToggle(user.id)}
              />
              <span className="truncate">{name}</span>
            </label>
            {member && (
              <Select
                className="min-h-11 w-36"
                value={member.role}
                onChange={(event) =>
                  onRoleChange(user.id, event.target.value as CleaningTeamMemberRequest['role'])
                }
              >
                <option value="Member">Mitglied</option>
                {canLead && <option value="Leader">Leitung</option>}
              </Select>
            )}
          </div>
        );
      })}
    </div>
  );
}
